import React, { useContext } from "react";
import { themeContext } from "../../Context";

import { experienceData } from "../../Constant/constants";

import "./Experience.css";

const Experience = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="experience">
      {experienceData?.map((data) => (
        <div className="achievement">
          {/* darkMode */}
          <div
            className="circle"
            style={{ color: darkMode ? "var(--orange)" : "" }}
          >
            {data.years}
          </div>
          <span style={{ color: darkMode ? "white" : "" }}>
            {data.textOne}{" "}
          </span>
          <span>{data.textTwo}</span>
        </div>
      ))}
    </div>
  );
};

export default Experience;
